import { addDays, addMonths, format } from 'date-fns';

/**
 * デフォルトのレポート集計期間を計算します。
 * toDate = now の前日
 * reportDateFrom = toDate の 1ヶ月前
 * reportDateTo = toDate
 */
export function getDefaultReportDateRange(now: Date): {
  reportDateFrom: string;
  reportDateTo: string;
} {
  const toDate = addDays(now, -1);
  const reportDateFrom = format(addMonths(toDate, -1), 'yyyy/MM/dd');
  const reportDateTo = format(toDate, 'yyyy/MM/dd');
  return { reportDateFrom, reportDateTo };
}
